import AccordionV2 from "@Components/Accordian";
import styles from "./FormPolicies.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const FromPolicies = ({ policies }: any) => {
  const policyData = policies.map((policy: any) => ({
    title: policy.display_name,
    description: policy.value,
  }));

  return (
    <AccordionV2
      data={policyData}
      isDesktop
      className={styles.accordionItem}
      sectionClassname={styles.sectionClassname}
      dividerClassname={styles.dividerClassname}
    />
  );
};

export default wrapperHOC(FromPolicies, {
  componentName: "FromPolicies-FormLayout-Global",
  showForChina: true,
});
